import { Page } from '@app/components/page/Page';
import { SocialExportBreadcrumbs } from '@app/modules/social-export/components/breadcrumbs/SocialExportBreadcrumbs';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { connectionsManageMessages as messages } from '../connections-manage-messages';

interface Props {
  platform: SocialPlatform;
  /** Connection label shown in the page title (custom name or profile display name). */
  connectionName?: ReactNode;
  children: ReactNode;
}

/**
 * Layout shell for connection-level settings configuration.
 */
export function BasePlatformSettingsPage({ platform, connectionName, children }: Props) {
  const title = (
    <FormattedMessage
      {...messages.settingsTitle}
      values={{ name: connectionName ?? platform.name }}
    />
  );

  return (
    <Page>
      <Page.Header
        icon={platform.Icon()}
        title={title}
        breadcrumbs={<SocialExportBreadcrumbs platform={platform} />}
      />
      <Page.Content>{children}</Page.Content>
    </Page>
  );
}
